module.exports = __webpack_public_path__ + "img/hbut_logo.8babcd2c.png";